module.exports = {
  EnrichedAudio: {
    Allow_fullscreen: "Tam ekrana izin ver",
    Show_controls: "Kontrol butonlarını göster",
    Autoplay: "Otomatik oynat",
    Waves: "Dalga",
    WaveColor: "Dalga rengi",
    ProgressColor: "İlerleme rengi",
    BarWidth: "Çubuk genişliği",
    URL: "URL",
    Audio: "Ses",
    background_color: "Arka Plan Rengi",
    border_color: "Çerçeve Rengi",
    border_size: "Çerçeve Genişliği",
    border_style: "Çerçeve Stili",
    box_style: "Kutu Stili",
    opacity: "Opaklık",
    padding: "Alan",
    PluginName: "Ses Oynatıcı",
    player: "Player Stili",
    radius: "Radyan",
    pos: "Konum",
    source: "Kaynak",
    Scroll: "Kaydır",
    message_mark_error:
      "Yanlış bir değer seçtiniz.  Zaman formatı şu şekilde olmalıdır: saat:dakika:saniye veya dakika:saniye. Örneğin 1:33",
  },
};
